module.exports = __webpack_public_path__ + "static/img/1.f3564a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/1.png
// module id = YDax
// module chunks = 23